import { Stack } from '@mui/material'
import { Footer, LoadingSkeleton, PageGridContainer, PageGridItem, tokens } from 'ComponentLibrary'
import { ReactNode } from 'react'
import { Outlet } from 'react-router-dom'

export default function AssetPageLayoutLoading({ breadcrumbs }: { breadcrumbs: ReactNode }) {
    return (
        <Stack direction="column" minHeight="100%" bgcolor={tokens.ColorBackgroundDark} gap={tokens.SizingSpacing300}>
            <Stack direction="column" gap={tokens.SizingSpacing300}>
                <PageGridContainer background={`linear-gradient(${tokens.ColorBackgroundLight} 194px, transparent 194px)`}>
                    <PageGridItem columnSpan={6} columnSpanXs={4}>
                        <Stack direction="row" paddingTop={tokens.SizingSpacing200} gap={tokens.SizingSpacing300} width="100%">
                            <Stack direction="column" gap={tokens.SizingSpacing400} width="max(570px, calc(100% - 390px))">
                                <Stack
                                    direction="column"
                                    gap={tokens.SizingSpacing300}
                                    paddingBottom={tokens.SizingSpacing100}
                                    width="100%"
                                >
                                    {breadcrumbs}
                                    <Stack
                                        direction="row"
                                        gap={tokens.SizingSpacing400}
                                        height="120px"
                                        justifyContent="space-between"
                                        width="100%"
                                    >
                                        <Stack direction="column" justifyContent="space-between">
                                            <Stack direction="column" gap={tokens.SizingSpacing075}>
                                                <LoadingSkeleton variant="rounded" height="24px" width="214px" />
                                                <LoadingSkeleton variant="rounded" height="34px" width="490px" />
                                            </Stack>
                                            <Stack direction="row" gap={tokens.SizingSpacing100} alignItems="center" height="24px">
                                                <LoadingSkeleton variant="rounded" height="24px" width="214px" />
                                            </Stack>
                                        </Stack>
                                        <Stack direction="column" alignItems="flex-end" alignSelf="flex-end" gap={tokens.SizingSpacing150}>
                                            <LoadingSkeleton variant="rounded" height="24px" width="200px" />
                                            <LoadingSkeleton variant="rounded" height="24px" width="200px" />
                                            <LoadingSkeleton variant="rounded" height="24px" width="200px" />
                                        </Stack>
                                    </Stack>
                                </Stack>
                                <LoadingSkeleton variant="rounded" height="40px" width="100%" />
                            </Stack>
                            <div style={{ backgroundColor: tokens.ColorBackgroundDark }}>
                                <LoadingSkeleton variant="rounded" width="366px" height="241px" />
                            </div>
                        </Stack>
                    </PageGridItem>
                </PageGridContainer>

                <Outlet />
            </Stack>

            <Footer withTopSpace />
        </Stack>
    )
}
